// @flow

import type {
  AuthState,
  ResetPasswordOperation,
} from '../../types'

export default function resetOperation (state: { auth: AuthState }): ?ResetPasswordOperation {
  return state.auth.resetPasswordOperation
}
